"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const P = styled_components_1.default.p `
  margin: 0;
  font-weight: 400;
  text-align: ${(props) => props.align || "left"};

  ${(props) => props.inverted &&
    styled_components_1.css `
      color: ${(props) => props.theme.colors.textInvertedPrimary};
    `}

  ${(props) => props.variant === "display3" &&
    styled_components_1.css `
      font-weight: 600;
      font-family: "Work Sans";
      font-size: ${(props) => props.theme.sizes.plusFive};
      line-height: 1.2;
    `};

  ${(props) => props.variant === "display2" &&
    styled_components_1.css `
      font-family: "Work Sans";
      font-size: ${(props) => props.theme.sizes.plusFour};
      font-weight: 600;
      line-height: 1.2;
    `};

  ${(props) => props.variant === "display1" &&
    styled_components_1.css `
      font-family: "Work Sans";
      font-weight: 600;
      font-size: ${(props) => props.theme.sizes.plusThree};
      line-height: 1.2;
    `};

  ${(props) => props.variant === "subheading" &&
    styled_components_1.css `
      font-family: "Work Sans";
      font-weight: 500;
      line-height: 1.2;
      font-size: ${(props) => props.theme.sizes.plusOne};
      color: ${(props) => props.theme.colors.textSecondary};

      ${props.inverted &&
        styled_components_1.css `
        color: ${(props) => props.theme.colors.textInvertedSecondary};
      `}
    `};

  ${(props) => props.variant === "title" &&
    styled_components_1.css `
      font-family: "Work Sans";
      font-weight: 600;
      font-size: ${(props) => props.theme.sizes.plusTwo};
      line-height: 1.2;
    `};

  ${(props) => props.variant === "subtitle" &&
    styled_components_1.css `
      line-height: 1.2;
      font-family: "Work Sans";
      font-weight: 700;
      text-transform: uppercase;
      font-size: ${(props) => props.theme.sizes.negOne};
      color: ${(props) => props.theme.colors.textSecondary};

      ${props.inverted &&
        styled_components_1.css `
        color: ${(props) => props.theme.colors.textInvertedSecondary};
      `}
    `};

  ${(props) => props.variant === "body2" &&
    styled_components_1.css `
      font-weight: 600;

      a {
        text-decoration: none;
      }
    `};

  ${(props) => props.variant === "body3" &&
    styled_components_1.css `
      color: ${(props) => props.theme.colors.textSecondary};

      ${props.inverted &&
        styled_components_1.css `
        color: ${(props) => props.theme.colors.textInvertedSecondary};
      `}
    `};

  ${(props) => props.gutterBottom &&
    styled_components_1.css `
      margin-bottom: ${props.theme.spacing.small};
    `};

  ${(props) => props.gutterTop &&
    styled_components_1.css `
      margin-top: ${props.theme.spacing.small};
    `};

  ${(props) => props.strike &&
    styled_components_1.css `
      text-decoration: line-through;
    `};

  ${(props) => props.color &&
    styled_components_1.css `
      color: ${props.color};
    `};

  ${(props) => props.element === "div" &&
    styled_components_1.css `
      > * {
        margin: 0;
      }

      > *:not(:last-child)  {
        margin-bottom: ${props.theme.spacing.small};
      }
    `}
`;
const H1 = P.withComponent("h1");
const H2 = H1.withComponent("h2");
const H3 = H2.withComponent("h3");
const Span = P.withComponent("span");
const Div = Span.withComponent("div");
const Text = ({ element, html, children, ...rest }) => {
    let Elem;
    switch (element) {
        case "h1":
            Elem = H1;
            break;
        case "h2":
            Elem = H2;
            break;
        case "h3":
            Elem = H3;
            break;
        case "span":
            Elem = Span;
            break;
        case "div":
            Elem = Div;
            break;
        default:
            Elem = P;
            break;
    }
    return (react_1.default.createElement(Elem, Object.assign({}, rest, { element: element, dangerouslySetInnerHTML: html ? { __html: html } : undefined }), children));
};
exports.default = Text;
